import { useState } from 'react';

interface EvidenceItem {
  claim: string;
  evidence: string;
  source_endpoint?: string;
}

interface EvidenceSectionProps {
  title: string;
  items: EvidenceItem[];
}

export default function EvidenceSection({ title, items }: EvidenceSectionProps) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="border border-ti-border rounded-lg overflow-hidden">
      {/* Header */}
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-5 py-3 bg-ti-surface hover:bg-ti-surface-hover transition-colors duration-200 cursor-pointer"
      >
        <h3 className="text-sm font-semibold text-ti-text uppercase tracking-wider">
          {title}
        </h3>
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className={`text-ti-text-dim transition-transform duration-300 ${
            expanded ? 'rotate-180' : ''
          }`}
        >
          <path
            d="M4 6L8 10L12 6"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Collapsible body */}
      <div
        className="transition-all duration-300 ease-in-out overflow-hidden"
        style={{
          maxHeight: expanded ? `${items.length * 200}px` : '0px',
          opacity: expanded ? 1 : 0,
        }}
      >
        <div className="divide-y divide-ti-border/50">
          {items.map((item, i) => (
            <div key={i} className="px-5 py-4 space-y-2">
              <p className="text-sm font-semibold text-ti-text">
                {item.claim}
              </p>
              <p className="text-sm text-ti-text-muted leading-relaxed">
                {item.evidence}
              </p>
              {item.source_endpoint && (
                <span className="inline-block px-2 py-0.5 text-[10px] font-mono text-ti-cyan bg-ti-cyan/10 rounded-full border border-ti-cyan/20">
                  {item.source_endpoint}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
